{
  "competition_details": "Kilpailun tiedot",
  "view_coming_soon": "Kilpailunäkymä tulossa pian",
  "coming_soon": "Tulossa pian",
  "player_view_description": "Tämä ominaisuus mahdollistaa kilpailun tietojen katsomisen, ilmoittautumisen kilpailuihin ja tulosten seuraamisen.",
  "fees": {
    "title": "Osallistumismaksu",
    "compulsory_description": "Osallistumismaksu on pakollinen. Maksu suoritetaan ilmoittautumisen yhteydessä.",
    "voluntary_description": "Osallistumismaksu on vapaaehtoinen. Voit maksaa ilmoittautumisen yhteydessä tai myöhemmin."
  },
  "view": {
    "load_failed": "Tapahtumaa ei löytynyt tai sen tietoja ei voitu ladata.",
    "public": "Julkinen",
    "notPublic": "Ei-julkinen",
    "live": "Live",
    "date": "Päivämäärä",
    "type": "Kilpailutyyppi",
    "description": "Kuvaus",
    "participants": "Osallistujat",
    "min_players": "Min: {{count}}",
    "ideal_players": "Tavoite: {{count}}",
    "features_coming_soon": "Ilmoittautumis- ja tuloslistaominaisuudet tulossa pian",
    "register": "Ilmoittaudu",
    "registration_period": "Ilmoittautumisaika",
    "start_times": "Lähtöajat",
    "no_participants": "Ei vielä ilmoittautuneita",
    "round": "Kierros",
    "no_start_times": "Lähtöaikoja ei ole vielä määritelty",
    "add_to_calendar": "Lisää kalenteriin"
  },
  "types": {
    "SINGLE": "Yksilökilpailu",
    "TEAM": "Joukkuekilpailu",
    "EVENT": "Tapahtuma",
    "WEEKLY": "Viikkokilpailu",
    "MATCHPLAY": "Match play"
  },
  "typeDescriptions": {
    "SINGLE": "Yksilökilpailu, jossa jokainen pelaaja pelaa omaa tulosta",
    "TEAM": "Joukkuekilpailu, jossa 2-4 hengen joukkueet kilpailevat keskenään.\n\nPelimuodot: Greensome, Foursome, Scramble, Best Ball ja Irish Rumble",
    "WEEKLY": "Viikkokilpailu, johon pelaajat voivat tallentaa useita tuloksia ja parhaat tulokset huomioidaan lopputulokseen",
    "EVENT": "Muu tapahtuma, jossa ei ole tuloslaskentaa. Esimerkiksi pro:n kurssi, yhtiökokous tai klubimatka",
    "MATCHPLAY": "Ottelutyyppinen kilpailu, jossa pelaajat tai joukkueet pelaavat toisiaan vastaan ottelumuotoisesti kaavio- tai liigamuotoisesti, esim. reikäpeli"
  },
  "playTypes": {
    "SINGLE": "Yksilöpeli",
    "STROKE_PLAY": "Lyöntipeli",
    "STABLEFORD": "Pistebogey",
    "PAR_BOGEY": "Par/Bogey",
    "MATCH_PLAY": "Reikäpeli",
    "GREENSOME": "Greensome",
    "FOURSOME": "Foursome",
    "SCRAMBLE": "Scramble",
    "BEST_BALL": "Best Ball",
    "FOUR_BALL": "Four Ball (2 pelaajaa)",
    "IRISH_RUMBLE": "Irish Rumble",
    "MATCH": "Joukkueottelu (Ryder Cup -tyylinen)",
    "BRACKET": "Kaavio (reikäpeli)",
    "LEAGUE": "Liiga"
  },
  "filters": {
    "all_clubs": "Kaikki seurat",
    "no_tenant": "Ei seuraa"
  },
  "list": {
    "search_placeholder": "Hae tapahtumia...",
    "create_competition": "Luo tapahtuma",
    "public_calendar": "Julkinen kalenteri",
    "no_competitions_found": "Tapahtumia ei löytynyt",
    "no_competitions_for_search": "Tapahtumia ei löytynyt haulle \"{{searchTerm}}\" vuodelta {{year}}.",
    "no_competitions_for_year": "Tapahtumia ei löytynyt vuodelta {{year}}.",
    "failed_to_load": "Tapahtumien lataaminen epäonnistui",
    "try_again": "Yritä uudelleen",
    "click_to_edit": "Klikkaa muokataksesi tapahtumaa",
    "has_waitlist": "Tapahtumassa on osallistujia jonossa",
    "show_older": "Näytä menneet",
    "upcoming": "Tulevat",
    "all": "Kaikki"
  },
  "public_calendar": {
    "page_title": "Kilpailukalenteri",
    "tenant_not_found": "Seuraa ei löytynyt",
    "meta_description": "{{club}} kilpailukalenteri – kaikki tulevat golfkilpailut",
    "login": "Kirjaudu",
    "empty": "Ei julkisia kilpailuita"
  },
  "table": {
    "start_date": "Pvm.",
    "name": "Nimi",
    "type": "Tyyppi",
    "tenant": "Seura",
    "courses": "Kentät",
    "status": "Tila",
    "participants": "Osallistujat"
  },
  "form": {
    "selectTypeTitle": "Valitse tapahtuman tyyppi",
    "matchplayTeamSizeTitle": "Ottelu — pelaajien määrä",
    "matchplayTeamSizeHelp": "Valitse, kuinka monta pelaajaa on yhdessä joukkueessa.",
    "matchplayTeamSizeLabel": "Pelaajia joukkueessa",
    "matchplayTeamSizeHint": "1 = yksilökilpailu, 2 = parikilpailu (esim. Foursome, Greensome), 3–4 = joukkue (Scramble).",
    "matchplayTeamSizeBack": "Takaisin",
    "matchplayTeamSizeContinue": "Jatka",
    "matchplayTeamSizeOptionTitle": {
      "1": "Yksilökilpailu",
      "2": "Parikilpailu",
      "3": "3 hengen joukkue",
      "4": "4 hengen joukkue"
    },
    "matchplayTeamSizeOptionTag": {
      "1": "Reikäpeli · Pistebogey · Lyöntipeli",
      "2": "Foursome · Greensome · Scramble",
      "3": "Scramble",
      "4": "Scramble"
    },
    "createCompetition": "Luo tapahtuma",
    "tabs": {
      "eventInfo": "Tapahtuma",
      "series": "Sarjat",
      "teams": "Joukkueet",
      "participants": "Osallistujat",
      "rounds": "Kierrokset",
      "flights": "Lähdöt",
      "scoring": "Tulokset",
      "results": "Tuloskortit",
      "matchplay": "Kaaviot"
    },
    "fields": {
      "name": "Tapahtuman nimi",
      "type": "Tapahtuman tyyppi",
      "startDate": "Alkupäivä",
      "endDate": "Loppupäivä",
      "description": "Kuvaus",
      "maxParticipants": "Osallistujien enimmäismäärä",
      "registrationOpens": "Ilmoittautuminen alkaa",
      "registrationCloses": "Ilmoittautuminen päättyy",
      "min_team_size": "Joukkueen vähimmäiskoko",
      "max_team_size": "Joukkueen enimmäiskoko",
      "competitionImage": "Kilpailun logo",
      "invitation": "Kutsu",
      "maxScoresPerPlayer": "Tulosten enimmäismäärä",
      "countingScores": "Laskettavat tulokset",
      "themeColor": "Teemaväri",
      "chooseThemeColor": "Valitse teemaväri",
      "cancellationDeadline": "Peruutuksen takaraja",
      "registrationRestriction": "Salli ilmoittautuminen",
      "allowedClubs": "Valitse seurat",
      "publicDescription": "Julkinen kuvaus",
      "publicDescriptionSociety": "Kuvaus jäsenille",
      "publicUrl": "Julkinen linkki",
      "publicUrlSociety": "Tapahtuman linkki",
      "allowWaitlist": "Salli jono",
      "cartWishEnabled": "Näytä osallistujalle golfautovalinta",
      "cartWishInfoText": "Golfautotoiveen lisätiedot",
      "liveScoringHiddenHoles": "Piilota viimeiset reiät livescoring-tuloksista",
      "tenant": "Asiakas",
      "participantVisibility": "Osallistujien näkyvyys"
    },
    "restriction_options": {
      "ALL_PLAYERS": "Kaikille pelaajille",
      "EBIRDIE_MEMBERS": "Vain Golfliiton jäsenille",
      "HOME_CLUB_MEMBERS": "Vain kotiseuran pelaajille",
      "SELECTED_CLUBS": "Valituille seuroille"
    },
    "visibility_audience_options": {
      "EVERYONE": "Kaikille",
      "PARTICIPANTS": "Vain osallistujille",
      "HIDDEN": "Piilotettu"
    },
    "visibility_audience_badge": {
      "EVERYONE": "Kaikki",
      "PARTICIPANTS": "Osallistujat",
      "HIDDEN": "Piilotettu"
    },
    "name": "Nimi",
    "name_placeholder": "Anna tapahtuman nimi",
    "start_date": "Alkupäivä",
    "participation_enabled": "Ilmoittautuminen sallittu",
    "is_public": "Julkinen",
    "placeholders": {
      "name": "Anna tapahtuman nimi",
      "description": "Tapahtuman kuvaus...",
      "maxParticipants": "esim. 144",
      "cartWishInfoText": "Esim. vain lääkärin todistuksella",
      "new_competition": "Uusi tapahtuma",
      "searchClubs": "Hae seuraa...",
      "selectType": "Valitse tyyppi...",
      "noTenant": "Ei asiakasta"
    },
    "switches": {
      "publicLabel": "Julkinen",
      "publicLabelSociety": "Näytä jäsenille",
      "subCompetitionLabel": "Lisää joukkuekilpailu",
      "participationLabel": "Ilmoittautuminen sallittu",
      "allowTeeSelectionLabel": "Pelaaja voi valita tiin",
      "allowAbnormalTeesLabel": "Salli poikkeavat tiit",
      "cancellationLabel": "Peruutus sallittu",
      "liveScoringEnabledLabel": "Livescoring käytössä"
    },
    "hints": {
      "descriptionCounter": "/5000 merkkiä",
      "publicDescriptionHint": "Näkyy julkisessa tapahtumakalenterissa",
      "publicDescriptionHintSociety": "Näkyy jäsenille",
      "publicUrlCopy": "Kopioi linkki",
      "publicUrlOpen": "Avaa uudessa välilehdessä",
      "maxScoresPerPlayer": "Kuinka monta tulosta pelaaja voi jättää",
      "countingScores": "Kuinka monta parasta tulosta lasketaan",
      "allowTeeSelection": "Jos pois päältä, pelaaja pelaa sarjan mukaisesta tiistä sukupuolensa perusteella",
      "allowAbnormalTees": "Jos päällä, ylläpitäjä voi määritellä osallistujalle poikkeavan tiin",
      "allowTeeSelectionRoundInfo": "Tämä asetus määritetään kilpailun tasolla. Muokkaa kilpailun asetuksia vaihtaaksesi tätä.",
      "liveScoringHiddenHolesHelp": "Piilotetut reiät tulevat näkyviin, kun tulokset julkaistaan"
    },
    "placeholders_tab": {
      "seriesTitle": "Sarjojen hallinta",
      "seriesDescription": "Sarjojen määritys tulee saataville tässä.",
      "participantsTitle": "Osallistujien hallinta",
      "participantsDescription": "Osallistujien ilmoittautuminen ja hallinta tulee saataville tässä.",
      "roundsTitle": "Kierrosten hallinta",
      "roundsDescription": "Kierrosten määritys tulee saataville tässä."
    },
    "actions": {
      "cancel": "Peruuta",
      "create": "Luo tapahtuma",
      "update": "Päivitä tapahtuma",
      "delete": "Poista tapahtuma",
      "save": "Tallenna tapahtuma",
      "saving": "Tallennetaan..."
    },
    "messages": {
      "unsavedChanges": "Sinulla on tallentamattomia muutoksia. Älä unohda tallentaa työtäsi!",
      "unsaved_cancel_confirm": "Haluatko varmasti peruuttaa? Kaikki tallentamattomat muutokset menetetään."
    },
    "errors": {
      "not_found": "Tapahtumaa ei löytynyt",
      "no_permission_edit": "Sinulla ei ole oikeutta muokata tätä tapahtumaa",
      "no_permission_delete": "Sinulla ei ole oikeutta poistaa tätä tapahtumaa",
      "failed_to_load": "Tapahtuman tietojen lataaminen epäonnistui",
      "failed_to_update": "Tapahtuman päivittäminen epäonnistui. Yritä uudelleen.",
      "failed_to_delete": "Tapahtuman poistaminen epäonnistui. Yritä uudelleen.",
      "invalid_data": "Virheelliset tapahtuman tiedot",
      "duplicate_name_date": "Samanniminen tapahtuma on jo olemassa tälle päivälle",
      "start_date_required": "Alkupäivä on pakollinen",
      "failed_to_create": "Tapahtuman luonti epäonnistui"
    },
    "success": {
      "updated": "Tapahtuma \"{{name}}\" päivitetty onnistuneesti!",
      "deleted": "Tapahtuma \"{{name}}\" poistettu onnistuneesti"
    },
    "copy": {
      "title": "Kopioi tapahtuma",
      "description": "Luo uusi tapahtuma kopioimalla nykyinen. Kaikki sarjat, kierrokset ja asetukset kopioidaan. Osallistujia ja tuloksia ei kopioida.",
      "button": "Kopioi",
      "success": "Tapahtuma \"{{name}}\" kopioitu onnistuneesti!",
      "failed": "Tapahtuman kopiointi epäonnistui"
    },
    "delete_confirm": {
      "header": "Poista tapahtuma",
      "body": "Haluatko varmasti poistaa tapahtuman \"{{name}}\"?\n\nTätä toimintoa ei voi perua ja se poistaa pysyvästi tapahtuman ja kaikki siihen liittyvät tiedot.",
      "button": "Poista tapahtuma"
    },
    "edit": {
      "title": "Muokkaa tapahtumaa",
      "failed_to_load_title": "Tapahtuman lataaminen epäonnistui",
      "back_button": "Takaisin tapahtumakalenteriin"
    },
    "participants": {
      "no_series_created": "Sarjoja ei ole vielä luotu. Luo sarjat ensin hallitaksesi osallistujia.",
      "select_series": "Valitse sarja osallistujien hallintaa varten"
    },
    "cannot_delete_has_participants": "Kilpailua ei voi poistaa, koska siinä on {{count}} vahvistettua osallistujaa. Poista ensin osallistujat."
  },
  "competition_info": {
    "basic_info_title": "Perustiedot",
    "registration_settings_title": "Ilmottautumisasetukset",
    "media_title": "Visuaalinen ilme ja liitteet"
  },
  "competition_form": {
    "categories_label": "Kategoriat",
    "categories_placeholder": "Valitse kategoriat..."
  },
  "categories": {
    "title": "Kategoriat",
    "create": "Lisää kategoria",
    "edit_category": "Muokkaa kategoriaa",
    "name_label": "Kategorian nimi",
    "slug_label": "URL-tunniste",
    "url_label": "Sivun osoite",
    "url_help_immutable": "Osoite luodaan automaattisesti nimestä eikä sitä voi muuttaa jälkikäteen.",
    "open_url": "Avaa uudessa välilehdessä",
    "url_preview_label": "Osoite:",
    "url_preview_empty": "(annetaan nimen perusteella)",
    "edit": "Muokkaa",
    "delete": "Poista",
    "delete_confirm_title": "Poista kategoria?",
    "delete_confirm_body": "Tämä kategoria on liitetty {{count}} kilpailuun. Poistaminen poistaa kategoriatunnisteen näistä kilpailuista, mutta itse kilpailut säilyvät. Haluatko jatkaa?",
    "filter_label": "Suodata kategorian mukaan",
    "filter_all_option": "Kaikki kategoriat",
    "empty_state_for_category": "Ei kilpailuja kategoriassa {{category}} vuonna {{year}}.",
    "no_categories_yet": "Ei kategorioita",
    "empty_state_help": "Kategorioilla ryhmittelet kilpailut, ja pelaajat voivat suodattaa niitä tapahtumakalenterissa.",
    "duplicate_name_error": "Samanniminen kategoria on jo olemassa.",
    "duplicate_slug_error": "Tämä URL-tunniste on jo käytössä.",
    "created_success": "Kategoria luotu",
    "updated_success": "Kategoria päivitetty",
    "deleted_success": "Kategoria poistettu",
    "failed_to_load": "Kategorioiden lataaminen epäonnistui",
    "failed_to_save": "Tallennus epäonnistui",
    "failed_to_delete": "Poisto epäonnistui"
  },
  "series": {
    "title": "Sarjat",
    "add_series": "Lisää sarja",
    "edit_series": "Muokkaa sarjaa",
    "create_series": "Luo sarja",
    "delete_series": "Poista sarja",
    "select_series_to_edit": "Valitse muokattava sarja",
    "no_series": "Ei sarjoja",
    "no_series_message": "Tälle tapahtumalle ei ole vielä luotu sarjoja.",
    "failed_to_load_series": "Sarjojen lataaminen epäonnistui",
    "series_created_successfully": "Sarja luotu onnistuneesti",
    "series_updated_successfully": "Sarja päivitetty onnistuneesti",
    "series_deleted_successfully": "Sarja poistettu onnistuneesti",
    "save_failed": "Sarjan tallennus epäonnistui",
    "delete_failed": "Sarjan poisto epäonnistui",
    "cannot_delete_has_participants": "Sarjaa ei voi poistaa, koska siinä on {{count}} vahvistettua osallistujaa. Poista ensin osallistujat.",
    "new_series": "Uusi sarja",
    "series_details": "Sarjan tiedot",
    "confirm_delete_series": "Haluatko varmasti poistaa tämän sarjan?",
    "form": {
      "basic_info_title": "Perustiedot",
      "handicap_settings_title": "Tasoitusasetukset",
      "name": "Sarjan nimi",
      "name_placeholder": "Esim. Miehet A-sarja",
      "gender": "Sukupuoli",
      "gender_help": "Valitse sukupuolet, jotka voivat osallistua tähän sarjaan",
      "age_min": "Ikä vähintään",
      "age_max": "Ikä enintään",
      "age_range": "Ikärajoitus",
      "hcp_min": "Tasoitus vähintään",
      "hcp_max": "Tasoitus enintään",
      "hcp_range": "Tasoitusrajoitus",
      "men_max_handicap": "Miesten maksimitasoitus (SAT)",
      "women_max_handicap": "Naisten maksimitasoitus (SAT)",
      "handicap_factor": "Tasoituskerroin",
      "max_participants": "Osallistujien enimmäismäärä",
      "allow_waitlist": "Salli jono",
      "min_team_size": "Joukkueen vähimmäiskoko",
      "max_team_size": "Joukkueen enimmäiskoko",
      "team_size": "Joukkuekoko",
      "team_size_max": "Pelaajia joukkueessa (max)",
      "team_size_min": "Pelaajia joukkueessa (min)",
      "allow_incomplete_teams": "Salli vajaat joukkueet",
      "team_handicap_percentages": "Joukkueen tasoitusprosentit",
      "team_handicap_percentages_help": "Prosentit jaetaan tasoituksen mukaan, alhaisin ensin",
      "player_percentage": "Pelaaja {{number}}",
      "cut_after_round": "CUT kierroksen jälkeen",
      "cut_line": "CUT jatkoon pääsee",
      "result_type": "Ensisijainen tulostyyppi",
      "draw_decision": "Tasatulosratkaisu",
      "secondary_result_type": "Toissijainen tulostyyppi",
      "secondary_draw_decision": "Tasatulosratkaisu",
      "no_secondary": "Ei toissijaista",
      "payment_mode": {
        "label": "Verkkomaksaminen",
        "not_in_use": "Ei käytössä",
        "compulsory": "Pakollinen",
        "voluntary": "Vapaaehtoinen",
        "not_available": "Maksuvaihtoehdot eivät ole käytössä.",
        "not_available_contact": "Ota yhteyttä ylläpitoon."
      }
    },
    "drawDecisions": {
      "SHARED_POSITION": "Jaettu sijoitus",
      "MATHEMATICAL": "Matemaattinen",
      "SLOPE_HANDICAP": "Slope-tasoitus",
      "EXACT_HANDICAP": "Tarkka tasoitus"
    },
    "tabs": {
      "general": "Yleistä",
      "tees": "Tiit"
    },
    "tees": {
      "title": "Sarjan tii-asetukset",
      "empty_no_rounds": "Luo ensin vähintään yksi kierros",
      "empty_no_rounds_help": "Sarjakohtaiset tiit vaativat kierroksen kentän ja tiipaikat.",
      "go_to_rounds": "Siirry kierroksiin",
      "column": {
        "mens_override": "Miesten tii",
        "womens_override": "Naisten tii"
      },
      "use_round_default": "Käytä kierroksen oletusta",
      "save": "Tallenna tii-asetukset",
      "saved_success": "Sarjan tii-asetukset tallennettu",
      "save_failed": "Tii-asetusten tallennus epäonnistui",
      "row": {
        "round_label": "KIERROS",
        "default_suffix": "(oletus)"
      }
    },
    "display": {
      "age_range": "Ikä: {{range}}",
      "hcp_range": "HCP: {{range}}",
      "max_participants": "Max: {{count}}",
      "current_participants": "{{current}}/{{max}} osallistujaa",
      "participants_count": "{{count}} osallistujaa",
      "full": "Täynnä",
      "all_genders": "Kaikki",
      "no_constraints": "Ei rajoituksia"
    },
    "match_play_description": "Määritä ja hallinnoi ottelupeliä tälle sarjalle. Luo kaavio, määritä vastakkainasettelut ja kirjaa ottelutulokset.",
    "configure_match_play": "Määritä kaavio ja ottelut"
  },
  "series_fees": {
    "payment_settings_title": "Hinnat ja maksaminen",
    "title": "Hinnat",
    "name": "Kuvaus",
    "amount": "Hinta",
    "add_fee": "+ Lisää hinta",
    "saved": "Maksut tallennettu",
    "no_fees": "Ei maksuja",
    "no_fees_info": "Sarjalle ei ole määritetty hintoja.",
    "add_fee_link": "Lisää hinta.",
    "name_placeholder": "Esim. Osallistumismaksu",
    "created": "Maksu lisätty",
    "updated": "Maksu päivitetty",
    "deleted": "Maksu poistettu",
    "load_failed": "Maksujen lataaminen epäonnistui",
    "save_failed": "Maksun tallennus epäonnistui",
    "delete_failed": "Maksun poisto epäonnistui",
    "invalid_amount": "Virheellinen summa",
    "delete_title": "Poista maksu",
    "confirm_delete": "Haluatko varmasti poistaa tämän maksun?"
  },
  "rounds": {
    "title": "Kierrokset",
    "add_round": "Lisää kierros",
    "edit_round": "Muokkaa kierrosta",
    "create_round": "Luo kierros",
    "delete_round": "Poista kierros",
    "new_round": "Uusi kierros",
    "no_rounds": "Ei kierroksia",
    "no_rounds_message": "Tälle tapahtumalle ei ole vielä luotu kierroksia.",
    "loading_rounds": "Ladataan kierroksia...",
    "failed_to_load_rounds": "Kierrosten lataaminen epäonnistui",
    "round_created_successfully": "Kierros luotu onnistuneesti",
    "round_updated_successfully": "Kierros päivitetty onnistuneesti",
    "round_deleted_successfully": "Kierros poistettu onnistuneesti",
    "failed_to_save_round": "Kierroksen tallennus epäonnistui",
    "failed_to_delete_round": "Kierroksen poisto epäonnistui",
    "cannot_delete_has_results": "Kierrosta ei voi poistaa, koska siihen on kirjattu tuloksia.",
    "confirm_delete_round": "Haluatko varmasti poistaa tämän kierroksen?",
    "round_details": "Kierroksen tiedot",
    "no_courses": "Kenttiä ei määritelty",
    "form": {
      "round_basics_title": "Kierroksen tiedot",
      "course_card_title": "Kenttä {{number}}",
      "schedule_section_title": "Tavoiteaikataulu",
      "date": "Kierrospäivä",
      "play_type": "Pelimuoto",
      "select_play_type_placeholder": "Valitse pelimuoto...",
      "counting_scores_per_team": "Tuloksia per joukkue",
      "courses": "Kentät",
      "course": "Kenttä",
      "missing-course": "Kierroksen tietoihin tulee määrittää vähintään yksi kenttä",
      "add_course": "Lisää kenttä",
      "remove_course": "Poista kenttä",
      "select_course": "Valitse kenttä",
      "select_course_placeholder": "Valitse kenttä...",
      "course_library_group": "Omat kentät",
      "course_catalog_group": "Kaikki kentät",
      "course_search_placeholder": "Hae kenttää...",
      "course_import_failed": "Kentän lisääminen epäonnistui",
      "course_unavailable": "Kenttä ei ole enää saatavilla",
      "course_color": "Kentän väri",
      "course_color_placeholder": "esim. Punainen, Sininen, Keltainen",
      "start_hole": "Aloitusväylä",
      "end_hole": "Lopetusväylä",
      "default_mens_tee": "Miesten oletustii",
      "default_womens_tee": "Naisten oletustii",
      "select_tee": "Valitse tii...",
      "time_schedule_template": "Tavoiteaikataulu",
      "no_time_template": "Ei tavoiteaikataulumallia",
      "no_templates_for_course": "Tälle kentälle ei ole määritelty aikataulumalleja.",
      "starting_arrangement": "Lähtöjärjestys",
      "handicap_settings_title": "Tasoitusasetukset",
      "ebirdie_settings_title": "eBirdie-asetukset",
      "men_max_handicap": "Miesten maksimitasoitus (SAT)",
      "women_max_handicap": "Naisten maksimitasoitus (SAT)",
      "handicap_factor": "Tasoituskerroin",
      "team_handicap_percentages": "Joukkueen tasoitusprosentit",
      "player_percentage": "Pelaaja {{number}}",
      "limit_team_handicap_to_min_slope": "Rajoita joukkueen tasoitus pienimpään yksilötasoitukseen",
      "affects_handicaps": "Vaikuttaa tasoituksiin",
      "automatically_send_scores": "Lähetä tulokset automaattisesti",
      "hints": {
        "maxHandicap": "SAT (Suurin Annettava Tasoitus) rajoittaa tasoituksen ennen slope-tasoituksen laskentaa. Esim. jos pelaajan tasoitus on 42.0 ja SAT = 36.0, laskennassa käytetään tasoitusta 36.0. Tyhjä = ei rajoitusta.",
        "handicapFactor": "Slope-tasoitus kerrotaan tasoituskertoimella ENNEN pyöristystä.",
        "teamHandicapPercentages": "Prosentit jaetaan tasoituksen mukaan, alhaisin tasoitus ensin. Esim. Greensome: 60% / 40%. Kunkin pelaajan henkilökohtainen slope-tasoitus kerrotaan kertoimella, minkä jälkeen tasoitukset lasketaan yhteen ENNEN pyöristystä",
        "limitTeamHandicapToMinSlope": "Kun päällä, joukkueen laskettu tasoitus ei voi olla suurempi kuin joukkueen parhaan pelaajan slope-tasoitus. Tasoitus rajataan pienimpään yksittäisen pelaajan slope-tasoitukseen.",
        "mensTeeRequired": "Sarjoissa on miespelaajia — miesten oletustii vaaditaan arvonnan slopelaskentaa varten.",
        "womensTeeRequired": "Sarjoissa on naispelaajia — naisten oletustii vaaditaan arvonnan slopelaskentaa varten.",
        "affects_handicaps": "Kun päällä, kierroksen tulokset ovat eBirdie-tasoitusilmoitukseen oikeutettuja",
        "automatically_send_scores": "Tasoitukset lähetetään automaattisesti klo {{time}}",
        "automatically_send_scores_disabled": "Ota käyttöön 'Vaikuttaa tasoituksiin' käyttääksesi automaattista lähetystä"
      }
    },
    "course_config": {
      "start_time": "Aloitusaika",
      "start_interval": "Lähtöväli (minuuttia)",
      "players_in_flight": "Pelaajia lähdössä",
      "teams_in_flight": "Joukkueita lähdössä"
    },
    "starting_arrangements": {
      "one_tee": "Peräkkäiset lähdöt yhdeltä tiiltä",
      "two_tees": "Peräkkäiset lähdöt kahdelta tiiltä",
      "shotgun": "Yhteislähtö"
    },
    "display": {
      "default_tees": "Miehet: {{menTee}}, Naiset: {{womenTee}}",
      "multi_course": "{{count}} kenttää"
    }
  },
  "flights": {
    "title": "Lähdöt",
    "delete_flights": "Poista lähdöt",
    "confirm_delete_flights": "Haluatko varmasti poistaa valitut lähdöt? Tätä toimintoa ei voi peruuttaa.",
    "deleted_successfully": "Lähdöt poistettu onnistuneesti",
    "delete_failed": "Lähtöjen poistaminen epäonnistui",
    "edit_entry_title": "Muokkaa lähtöä",
    "select_participant": "Valitse osallistuja",
    "no_flights": "Ei lähtöjä",
    "add_participant": "Lisää",
    "add_flights_button": "Lisää lähtöjä",
    "create_flights_modal_title": "Luo tyhjiä lähtöjä",
    "create_flights_count_label": "Lähtöjen määrä",
    "create_flights_count_validation": "Syötä positiivinen kokonaisluku",
    "create_flights_submit_button": "Luo",
    "flights_created": "Luotiin {{count}} lähtöä",
    "create_failed": "Lähtöjen luominen epäonnistui",
    "flight_lottery": "Arvonta",
    "run_lottery": "Suorita arvonta",
    "lottery_confirm_title": "Suorita lähtöjen arvonta",
    "lottery_confirm_body": "Tämä poistaa kaikki nykyiset lähdöt ja luo uudet satunnaisella osallistujien jaolla. Haluatko jatkaa?",
    "lottery_success": "Arvonta suoritettu onnistuneesti. Luotiin {{count}} lähtöä.",
    "lottery_failed": "Arvonnan suorittaminen epäonnistui",
    "lottery_mode": "Arvontatapa",
    "lottery_mode_random": "Vapaasti arvottu",
    "lottery_mode_registration_order": "Ilmoittautumisjärjestys",
    "lottery_mode_random_description": "Osallistujat arvotaan satunnaiseen järjestykseen",
    "lottery_mode_registration_order_description": "Osallistujat järjestetään ilmoittautumisjärjestyksen mukaan",
    "lottery_mode_results_reversed": "Tulosten perusteella käännetty",
    "lottery_mode_results_reversed_description": "Pelaajat järjestetään edellisten kierrosten tulosten mukaan - huonoimmat tulokset ensin",
    "lottery_by_series": "Arvonta sarjoittain",
    "lottery_by_series_description": "Kukin sarja arvotaan erikseen omiin lähtöihinsä",
    "lottery_by_series_disabled_single": "Kilpailussa on vain yksi sarja",
    "preserve_existing_order": "Säilytä nykyinen järjestys",
    "preserve_existing_order_description": "Uudet lähdöt lisätään olemassa olevien jatkoksi",
    "respect_start_time_preferences": "Huomioi lähtöaikatoiveet",
    "respect_start_time_preferences_description": "Aikaiseen aikaan haluavat sijoitetaan alkuun, myöhäiseen loppuun",
    "respect_start_time_preferences_note": "Lähtöaikatoiveiden huomioiminen ei ole aktiivinen ilmoittautumisjärjestyksessä",
    "reorder_success": "Lähtöjen järjestys päivitetty",
    "reorder_failed": "Lähtöjen järjestyksen päivitys epäonnistui",
    "entry_moved": "Osallistuja siirretty",
    "move_failed": "Siirto epäonnistui",
    "edit_flight": "Muokkaa lähtöä",
    "no_entries": "Ei pelaajia lähdössä",
    "no_participants": "Ei pelaajia",
    "empty_slot": "Tyhjä paikka",
    "unknown_participant": "Tuntematon osallistuja",
    "entry_removed": "Pelaaja poistettu lähdöstä",
    "remove_entry_failed": "Pelaajan poistaminen epäonnistui",
    "flight_updated": "Lähtö päivitetty",
    "update_failed": "Lähdön päivitys epäonnistui",
    "unsaved_changes_warning": "Sinulla on tallentamattomia muutoksia. Haluatko jatkaa?",
    "pdf_columns": "Valitse sarakkeet",
    "export_pdf": "Lataa PDF",
    "publish_flights": "Julkaise lähdöt",
    "flights_published": "Lähdöt julkaistu",
    "flights_unpublished": "Lähdöt piilotettu",
    "publish_toggle_failed": "Julkaisun muutos epäonnistui",
    "flights_not_published": "Lähtöjä ei ole julkaistu.",
    "publish_flights_link": "Julkaise.",
    "cut_was_needed_alert": "Edellisen kierroksen karsintaa ei ole suoritettu:",
    "check_cut_status": "Siirry suorittamaan karsinta sarjalle {{seriesName}}",
    "cannot_delete_has_results": "Lähtöjä, joilla on tallennettuja tuloksia, ei voi poistaa. Poista tulokset ensin.",
    "cannot_remove_entry_has_results": "Pelaajaa, jolla on tallennettuja tuloksia, ei voi siirtää tai poistaa lähdöstä. Poista tulokset ensin.",
    "publish_modal_title": "Julkaise lähdöt",
    "publish_modal_body": "Lähdöt ovat valmiina julkaistavaksi.",
    "publish_modal_notify_checkbox": "Lähetä lähtöaikailmoitus kaikille vahvistetuille osallistujille",
    "publish_modal_publish_button": "Julkaise",
    "publish_modal_audience_label": "Lähtöaikojen näkyvyys",
    "audience_modal_title": "Muuta lähtöaikojen näkyvyyttä",
    "audience_updated": "Näkyvyys päivitetty",
    "send_start_times_to_selected": "Lähetä lähtöajat valituille",
    "send_start_times_success": "Lähtöaikailmoitukset lähetetty",
    "send_start_times_failed": "Lähtöaikailmoitusten lähetys epäonnistui",
    "start_time_sent": "Lähtöaikailmoitus lähetetty",
    "start_time_not_sent": "Lähtöaikailmoitusta ei lähetetty",
    "send_start_time": "Lähetä lähtöaika sähköpostiin",
    "resend_start_time": "Lähtöaikailmoitus lähetetty — lähetä uudelleen",
    "resend_start_time_title": "Lähetä lähtöaikailmoitus",
    "resend_start_time_body": "Lähetä lähtöaikailmoitus pelaajalle <strong>{{name}}</strong> ({{email}})?",
    "start_time_no_email_address": "Pelaajalla ei ole sähköpostiosoitetta — ilmoitusta ei voi lähettää"
  },
  "results": {
    "scorecards": "Tuloskortit",
    "no_results": "Ei tuloksia",
    "edit_result_title": "Muokkaa tulosta",
    "edit_placeholder": "Tuloksen muokkausominaisuus tulossa pian...",
    "creating_result": "Luodaan tulosta...",
    "saving_result": "Tallennetaan tulosta...",
    "saving_all": "Tallennetaan kaikkia...",
    "deleting_result": "Poistetaan tulosta...",
    "delete_result": "Poista tulos",
    "delete_confirm": "Haluatko varmasti poistaa tämän tuloksen?",
    "result_saved": "Tulos tallennettu",
    "all_results_saved": "Kaikki tulokset tallennettu",
    "some_saves_failed": "{{count}} tuloksen tallennus epäonnistui",
    "result_deleted": "Tulos poistettu",
    "save_failed": "Tallentaminen epäonnistui",
    "delete_failed": "Poistaminen epäonnistui",
    "save_current": "Tallenna",
    "save_all_close": "Tallenna",
    "unsaved_changes_warning": "Sinulla on tallentamattomia muutoksia. Haluatko jatkaa?",
    "edit_flight": "Muokkaa lennon tuloksia",
    "edit_team_result": "Muokkaa joukkueen tulosta",
    "edit_player_result": "Muokkaa pelaajan tulosta",
    "scorecard_signed": "Tuloskortti allekirjoitettu",
    "disqualified": "Diskattu",
    "withdrawn": "Keskeyttänyt",
    "disqualification_reason": "Hylkäyksen syy",
    "does_not_affect_handicap": "Ei vaikuta tasoitukseen",
    "set_to_par_superuser": "Aseta pariin (superuser)",
    "editing_scorecard": "Muokataan tuloskorttia",
    "saved_successfully": "Tallennettu onnistuneesti",
    "hints": {
      "does_not_affect_handicap": "Kun päällä, tämän tuloskortin tulosta ei lähetetä eBirdieen"
    },
    "cut_needed_alert": "Tämän kierroksen karsintaa ei ole suoritettu:",
    "execute_cut": "Siirry suorittamaan karsinta sarjalle {{seriesName}}",
    "publish_results": "Julkaise tulokset",
    "results_published": "Tulokset julkaistu",
    "results_unpublished": "Tulokset piilotettu",
    "publish_toggle_failed": "Julkaisun muutos epäonnistui",
    "results_not_published": "Tuloksia ei ole julkaistu",
    "live": "Live",
    "refresh": "Päivitä",
    "publish_modal_title": "Julkaise tulokset",
    "publish_modal_body": "Julkaisu tuo tulokset näkyviin osallistujille ja julkiseen kisakalenteriin.",
    "publish_modal_body_society": "Julkaisu tuo tulokset näkyviin jäsenille.",
    "publish_modal_notify_checkbox": "Lähetä tulosilmoitus kaikille kierroksen pelaajille",
    "publish_modal_publish_button": "Julkaise",
    "publish_modal_audience_label": "Tulosten näkyvyys",
    "audience_modal_title": "Muuta tulosten näkyvyyttä",
    "audience_updated": "Näkyvyys päivitetty"
  },
  "scoring": {
    "select_series": "Valitse sarja",
    "no_series": "Ei sarjoja",
    "no_rounds": "Ei kierroksia",
    "no_results": "Ei tuloksia saatavilla",
    "error_loading_rankings": "Tulosten lataaminen epäonnistui",
    "playing_handicap_tooltip": "Pelitasoitus: {{value}}",
    "resultType": "Tulostyyppi",
    "resultTypes": {
      "strokeScratch": "Lyöntipeli Scratch",
      "strokeHcp": "Lyöntipeli HCP",
      "stablefordScratch": "Pistebogey Scratch",
      "stablefordHcp": "Pistebogey HCP",
      "maxScoreScratch": "Maksimitulos Scratch",
      "maxScoreHcp": "Maksimitulos HCP",
      "system36": "System 36"
    },
    "system36Handicap": "HCP",
    "round": "Kierros",
    "round_abbrev": "K",
    "cumulative": "Kumulatiivinen",
    "hole_details": "Reikäkohtaiset tulokset",
    "rank": "Sija",
    "team": "Joukkue",
    "player": "Pelaaja",
    "players": "Pelaajat",
    "score": "Tulos",
    "total": "Yhteensä",
    "front9": "Out",
    "back9": "In",
    "relative_to_par": "Par +/-",
    "par": "Par",
    "cut_line": "Karsintaraja",
    "apply_cut": "Suorita CUT",
    "remove_cut": "Poista CUT",
    "cut_applied_success": "CUT suoritettu: {{count}} pelaajaa karsiutui",
    "cut_removed_success": "CUT poistettu: {{count}} pelaajaa palautettu",
    "cut_apply_error": "CUT:n suorittaminen epäonnistui",
    "cut_remove_error": "CUT:n poistaminen epäonnistui",
    "cut_available_alert": "Karsinta tulee suorittaa:",
    "go_to_cut": "Siirry suorittamaan karsinta sarjalle {{seriesName}}",
    "cut_warning_title": "Varoitus: eri tulostyyppi",
    "cut_warning_confirm": "Suorita karsinta",
    "cut_result_type_mismatch_warning": "Varoitus: nykyinen tulostyyppi ei vastaa sarjan ensisijaista tulostyyppiä. Oletko varma, että haluat suorittaa karsinnan näiden tulosten perusteella?\n\nNykyinen tulostyyppi: {{currentType}}\nSarjan ensisijainen tulostyyppi: {{defaultType}}\nSarja: {{seriesName}}",
    "ties_broken_by": "Tasatilanteiden ratkaisu",
    "using_default_draw_decision": "Käytetään oletusarvoa: jaetut sijat, matemaattinen järjestys",
    "no_explicit_config": "Ei määritelty tälle tulostyypille",
    "primary_short": "Ensisij.",
    "secondary_short": "Toissij.",
    "team_results": "Joukkuetulokset",
    "individual_results": "Yksilötulokset",
    "cumulative_results": "Yhteistulokset",
    "no_valid_strokeplay_result": "Ei lyöntipelitulosta",
    "liveScoringLauncher": {
      "title": "Livescoring",
      "playersPerPage": "Pelaajia per sivu",
      "matchesPerPage": "Otteluita per sivu",
      "teamsPerPage": "Joukkueita per sivu",
      "rounds": "Näytettävät kierrokset",
      "roundsHint": "Valitse kierrokset, jotka haluat näyttää. Jätä tyhjäksi näyttääksesi kaikki.",
      "pageRotation": "Sivun vaihto",
      "seconds": "sekuntia",
      "off": "Pois",
      "showHoleDetails": "Reikäkohtaiset tulokset",
      "previewUrl": "Esikatsele URL",
      "openLiveView": "Avaa",
      "cancel": "Peruuta",
      "seriesToShow": "Näytettävät sarjat ja tulostyypit",
      "autoFit": "Automaattinen (sovita näyttöön)"
    },
    "flight_scoring": {
      "tabs": {
        "results": "Tulokset",
        "leaderboard": "Leaderboard"
      },
      "hole": "Reikä",
      "last_modified_by": "Viimeksi muokannut",
      "finish_button": "Valmista tulokset",
      "error_loading": "Tulosten lataaminen epäonnistui",
      "leaderboard_placeholder": "Leaderboard-näkymä tulossa pian",
      "exit_confirm_header": "Haluatko poistua?",
      "exit_confirm_body": "Voit jatkaa tulosten syöttöä myöhemmin. Syötetyt tulokset eivät katoa.",
      "exit_confirm_yes": "Kyllä",
      "exit_confirm_no": "Ei",
      "unsaved_changes_header": "Tallentamattomia muutoksia",
      "unsaved_changes_body": "Sinulla on tallentamattomia tuloksia tälle reiälle. Haluatko jatkaa tallentamatta vai palata tallennukseen?",
      "unsaved_changes_save": "Palaa tallennukseen",
      "unsaved_changes_continue": "Jatka tallentamatta",
      "saving": "Tallennetaan...",
      "not_started": "Ei aloitettu",
      "save_scores": "Tallenna tulokset",
      "review_scorecard": "Tarkista ja allekirjoita tuloskortit",
      "overwrite_confirm_title": "Olet muuttamassa reiän tulosta",
      "overwrite_confirm_notification_warning": "Muutos ilmoitetaan muille pelaajille!",
      "overwrite_confirm_old_score": "Vanha tulos",
      "overwrite_confirm_new_score": "Uusi tulos",
      "overwrite_confirm_removed": "poistettu",
      "overwrite_confirm_player_label": "Pelaaja",
      "overwrite_confirm_score_label": "Tulos",
      "notification_title": "Tuloksia muutettu",
      "notification_change_label": "Muutos",
      "notification_edited_by": "Muokkasi {{changedBy}}",
      "notification_changed_score": "{{changedBy}} muutti pelaajan {{playerName}} reiän {{hole}} tulosta",
      "notification_changed_score_team": "{{changedBy}} muutti joukkueen {{playerName}} reiän {{hole}} tulosta",
      "notification_changed_result": "muutti tulosta",
      "notification_change_label": "Muutos",
      "notification_edited_by": "Muokkasi {{changedBy}}",
      "notification_old_new": "Vanha: {{old}} → Uusi: {{new}}",
      "notification_score_removed": "poistettu",
      "notification_ok": "OK",
      "status_short_dq": "DQ",
      "status_short_wd": "WD"
    }
  },
  "registration": {
    "register_for_series": "Ilmoittaudu sarjaan",
    "first_name": "Etunimi",
    "last_name": "Sukunimi",
    "email": "Sähköposti",
    "phone": "Puhelinnumero",
    "gender": "Sukupuoli",
    "gender_male": "Mies",
    "gender_female": "Nainen",
    "gender_other": "Muu",
    "gender_not_specified": "Ei määritelty",
    "birth_year": "Syntymävuosi",
    "handicap_index": "Tasoitus",
    "tee_set": "Lähtöpaikka",
    "preferred_start_time": "Toivottu lähtöaika",
    "start_time_preference": "Lähtöaikatoive",
    "start_time_preference_none": "Ei toivetta",
    "start_time_preference_early": "Aikainen",
    "start_time_preference_late": "Myöhäinen",
    "no_preference": "Ei toiveita",
    "morning": "Aamu",
    "afternoon": "Iltapäivä",
    "evening": "Ilta",
    "notes": "Lisätiedot",
    "notes_placeholder": "Erityistoiveet tai lisätiedot...",
    "accept_terms": "Hyväksyn ilmoittautumisen ehdot",
    "register": "Ilmoittaudu",
    "registering": "Ilmoittaudutaan...",
    "registration_confirmed": "Ilmoittautuminen vahvistettu!",
    "added_to_waitlist": "Lisätty varasijalle",
    "registration_failed": "Ilmoittautuminen epäonnistui",
    "registration_full_waitlist": "Sarja on täynnä. Sinut lisätään varasijalle.",
    "team_size_info": "Tämä on joukkuetapahtuma. Joukkueessa tulee olla {{min}}-{{max}} pelaajaa. Lisää tuki useille pelaajille tulee pian.",
    "team_name": "Joukkueen nimi",
    "team_name_placeholder": "Syötä joukkueen nimi...",
    "team_size_requirement": "Joukkueessa tulee olla {{min}}-{{max}} pelaajaa",
    "player_number": "Pelaaja {{number}}",
    "participant_info": "Osallistujan tiedot",
    "add_player": "Lisää pelaaja",
    "errors": {
      "series_required": "Sarja vaaditaan",
      "terms_required": "Hyväksy ehdot jatkaaksesi",
      "generic": "Ilmoittautuminen epäonnistui. Yritä uudelleen.",
      "first_name_required": "Etunimi vaaditaan",
      "last_name_required": "Sukunimi vaaditaan",
      "email_required": "Sähköposti vaaditaan",
      "email_invalid": "Virheellinen sähköpostiosoite",
      "phone_required": "Puhelinnumero vaaditaan",
      "gender_required": "Sukupuoli vaaditaan",
      "birth_year_required": "Syntymävuosi vaaditaan",
      "handicap_required": "Tasoitus vaaditaan",
      "handicap_invalid": "Tasoituksen tulee olla välillä -10.0 - 54.0",
      "tee_set_required": "Lähtöpaikan valinta vaaditaan",
      "min_participants": "Joukkueessa tulee olla vähintään {{min}} pelaajaa",
      "max_participants": "Joukkueessa voi olla enintään {{max}} pelaajaa",
      "unsaved_participants": "Tallenna kaikki pelaajat ennen ilmoittautumisen lähettämistä"
    },
    "status": {
      "confirmed": "Vahvistettu",
      "waitlisted": "Varasija",
      "withdrawn": "Peruttu"
    }
  },
  "participation": {
    "searchPlayer": "Hae pelaajaa",
    "allPlayers": "Kaikki pelaajat",
    "allClubs": "Golfliiton jäsenet",
    "societyMembers": "Yhteisön jäsenet",
    "nameOrMemberNumber": "Nimi tai jäsennumero",
    "selectSocietyMember": "Valitse tai hae jäsen",
    "search": "Hae",
    "noResults": "Ei tuloksia",
    "already_registered": "Ilmoittautunut",
    "localPlayers": "Muut Impact-käyttäjät",
    "localSearchPlaceholder": "Hae nimellä tai sähköpostilla"
  },
  "participations": {
    "pdf_columns": "Valitse sarakkeet",
    "export_pdf": "Lataa PDF"
  },
  "pdf": {
    "filename_start_list": "lähtölista",
    "filename_participants": "osallistujat",
    "filename_results": "tulokset",
    "filename_team_results": "joukkue",
    "filename_individual_results": "yksilo"
  },
  "my_participations": {
    "title": "Omat ilmoittautumiset",
    "no_participations": "Et ole ilmoittautunut kilpailuihin.",
    "browse_competitions": "Selaa kilpailuja",
    "failed_to_load": "Ilmoittautumisten lataus epäonnistui",
    "registered_at": "Ilmoittautunut",
    "waitlist_position": "Varasijalla",
    "view_competition": "Näytä",
    "withdraw": "Peru",
    "withdrawal_successful": "Peruutus onnistui",
    "withdrawal_failed": "Peruutus epäonnistui",
    "withdraw_confirmation_title": "Peru ilmoittautuminen",
    "withdraw_confirmation_message": "Haluatko varmasti perua ilmoittautumisen?"
  },
  "timeSchedule": {
    "templates": "Tavoiteaikataulumallit",
    "addTemplate": "Lisää malli",
    "createTemplate": "Luo tavoiteaikataulu",
    "editTemplate": "Muokkaa tavoiteaikataulua",
    "templateName": "Aikataulun nimi",
    "templateNamePlaceholder": "Esim. Normaali kierros - viikonloppu",
    "expectedTimePerHole": "Aika per väylä (minuutteina)",
    "description": "Kuvaus",
    "descriptionPlaceholder": "Aikataulumallin kuvaus...",
    "selectScorecard": "Valitse tuloskortti",
    "selectScorecardPlaceholder": "Valitse tuloskortti...",
    "selectCourse": "Valitse kenttä",
    "selectCoursePlaceholder": "Valitse kenttä...",
    "holeTime": "Reikä {{number}}",
    "hole": "Reikä",
    "totalTime": "Tavoiteaika 18 reikää",
    "totalExpectedTime": "Tavoiteaika yhteensä",
    "minutes": "min",
    "applyToAll": "Aseta kaikille",
    "applyToAllHint": "Aseta sama aika kaikille väylille",
    "noTemplates": "Ei aikataulumalleja",
    "noTemplatesMessage": "Luo ensimmäinen aikataulumallisi määrittämään odotettu peliaika per väylä.",
    "createFirst": "Luo ensimmäinen malli",
    "loadingTemplates": "Ladataan malleja...",
    "failedToLoad": "Mallien lataaminen epäonnistui",
    "templateCreated": "Aikataulumalli luotu onnistuneesti",
    "templateUpdated": "Aikataulumalli päivitetty onnistuneesti",
    "templateDeleted": "Aikataulumalli poistettu onnistuneesti",
    "createFailed": "Mallin luominen epäonnistui",
    "updateFailed": "Mallin päivitys epäonnistui",
    "deleteFailed": "Mallin poistaminen epäonnistui",
    "confirmDelete": "Haluatko varmasti poistaa mallin \"{{name}}\"?",
    "deleteTemplate": "Poista malli",
    "deleteSuccess": "Malli poistettu onnistuneesti",
    "updateSuccess": "Malli päivitetty onnistuneesti",
    "createSuccess": "Malli luotu onnistuneesti",
    "saveTemplate": "Tallenna malli",
    "cancel": "Peruuta",
    "holes": "{{count}} reikää",
    "holeCount": "{{count}} reikää",
    "holesHeader": "Reiät",
    "course": "Kenttä",
    "manageTemplates": "Hallitse aikataulumalleja",
    "manageDescription": "Luo ja hallinnoi aikataulumalleja, joita voidaan käyttää kierrosten pelitahtien seurantaan.",
    "frontNine": "Reiät 1-9",
    "backNine": "Reiät 10-18",
    "frontNineTime": "Etuysin aika",
    "backNineTime": "Takaysin aika",
    "searchTemplates": "Hae aikataulumalleja",
    "duration": "Kesto",
    "out": "Ulos",
    "in": "Sisään",
    "errors": {
      "nameRequired": "Mallin nimi vaaditaan",
      "scorecardRequired": "Kenttä vaaditaan",
      "invalidTime": "Kaikki väylien ajat on asetettava vähintään 1 minuuttiin",
      "saveFailed": "Mallin tallennus epäonnistui",
      "loadFailed": "Mallien lataaminen epäonnistui",
      "deleteFailed": "Mallin poistaminen epäonnistui"
    }
  },
  "timeTracking": {
    "title": "Pelitahdin seuranta",
    "enableTracking": "Ota pelitahdin seuranta käyttöön",
    "selectTemplate": "Valitse aikataulumalli",
    "selectTemplatePlaceholder": "Valitse malli...",
    "noTemplate": "Ei valittua mallia",
    "warningThreshold": "Varoitusraja (minuuttia)",
    "warningThresholdHelp": "Näytä varoitus, kun ryhmä on tämän verran jäljessä aikataulusta",
    "dangerThreshold": "Vaaratason raja (minuuttia)",
    "dangerThresholdHelp": "Näytä vaaramerkki, kun ryhmä on tämän verran jäljessä aikataulusta",
    "overrideEnabled": "Ohita seuranta",
    "overrideReason": "Ohituksen syy",
    "overrideReasonPlaceholder": "Kerro miksi aikataulun seuranta on ohitettu, esim. sääolosuhteet...",
    "noTrackingConfigured": "Pelitahdin seurantaa ei ole määritetty tälle kilpailulle.",
    "configureTracking": "Määritä seuranta",
    "trackingEnabled": "Seuranta käytössä",
    "trackingDisabled": "Seuranta pois käytöstä",
    "saveSuccess": "Pelitahdin seuranta tallennettu",
    "deleteSuccess": "Pelitahdin seuranta poistettu",
    "saveFailed": "Pelitahdin seurannan tallennus epäonnistui",
    "deleteFailed": "Pelitahdin seurannan poisto epäonnistui",
    "confirmDelete": "Haluatko varmasti poistaa pelitahdin seurannan tältä kilpailulta?",
    "removeTracking": "Poista seuranta",
    "templateInfo": "Malli: {{name}}",
    "expectedTime": "Odotettu peliaika: {{time}}",
    "thresholds": "Kynnysarvot",
    "settings": "Asetukset"
  },
  "upcoming_competitions": "Tulevat kilpailut",
  "competition_round": "Kilpailukierros",
  "upload_image": "Lataa logo",
  "upload_invitation": "Lataa kutsu",
  "change_image": "Vaihda logo",
  "change_invitation": "Vaihda kutsu",
  "remove_image": "Poista logo",
  "remove_invitation": "Poista kutsu",
  "remove_theme_color": "Poista teemaväri",
  "image_uploaded": "Logo ladattu",
  "invitation_uploaded": "Kutsu ladattu",
  "image_removed": "Logo poistettu",
  "invitation_removed": "Kutsu poistettu",
  "failed_to_upload_image": "Logon lataaminen epäonnistui",
  "failed_to_upload_invitation": "Kutsun lataaminen epäonnistui",
  "failed_to_remove_image": "Logon poistaminen epäonnistui",
  "failed_to_remove_invitation": "Kutsun poistaminen epäonnistui",
  "invalid_file_type": "Virheellinen tiedostotyyppi",
  "invalid_invitation_type": "Virheellinen tiedostotyyppi. Sallitut: PDF, JPEG, PNG, WebP",
  "file_too_large": "Tiedosto on liian suuri",
  "uploading": "Ladataan...",
  "removing": "Poistetaan...",
  "view_button": "Näytä",
  "view_invitation": "Näytä kutsu",
  "invitation_formats": "PDF, JPEG, PNG, WebP",
  "admin": {
    "incompatible_series": "Yhteensopimattomat sarjat",
    "participation_management": "Osallistumisten hallinta",
    "confirmed": "Vahvistettu",
    "waitlisted": "Varasija",
    "waitlisted_divider": "Varasijalla",
    "withdrawn": "Peruttu",
    "disqualified": "Hylätty",
    "status_confirmed": "Osallistujat",
    "status_waitlisted": "Varasijalla",
    "status_withdrawn": "Peruttu",
    "status_pending": "Odottaa maksua",
    "search_by_name": "Hae nimellä...",
    "participant": "Osallistuja",
    "email": "Sähköposti",
    "handicap": "Tasoitus",
    "status": "Tila",
    "registered_at": "Ilmoittautunut",
    "actions": "Toiminnot",
    "no_participations": "Ei osallistumisia",
    "confirm": "Vahvista",
    "confirm_participation_message": "Haluatko varmasti vahvistaa tämän osallistumisen?",
    "move_to_waitlist": "Siirrä varasijalle",
    "refresh_data": "Päivitä tiedot",
    "disqualify": "Hylkää",
    "refresh_all": "Päivitä kaikki",
    "participation_confirmed": "Osallistuminen vahvistettu",
    "moved_to_waitlist": "Siirretty varasijalle",
    "participant_refreshed": "Osallistujan tiedot päivitetty",
    "all_participants_refreshed": "Kaikki osallistujat päivitetty",
    "participant_disqualified": "Osallistuja hylätty",
    "confirm_failed": "Vahvistus epäonnistui",
    "move_to_waitlist_failed": "Siirto varasijalle epäonnistui",
    "refresh_failed": "Tietojen päivitys epäonnistui",
    "refresh_all_failed": "Kaikkien päivitys epäonnistui",
    "disqualify_failed": "Hylkäys epäonnistui",
    "disqualification_reason_prompt": "Anna hylkäyksen syy:",
    "series": "Sarja",
    "add_participation": "Lisää osallistuja",
    "batch_actions": "Toiminnot",
    "batch_actions_disabled": "Valitse ensin osallistujat",
    "batch_withdraw": "Poista osallistumiset",
    "batch_confirm": "Siirrä osallistujiin",
    "capacity_exceeded": "Osallistujaraja ylitetty",
    "capacity_warning_competition": "Kilpailu on täynnä ({{current}}/{{max}} vahvistettua)",
    "capacity_warning_series": "Sarja \"{{seriesName}}\" on täynnä ({{current}}/{{max}} vahvistettua)",
    "admin_capacity_choice_prompt": "Haluatko lisätä osallistujan varasijalle vai vahvistaa osallistumisen ohittaen kapasiteettirajoituksen?",
    "add_to_waitlist": "Lisää varasijalle",
    "add_as_confirmed_bypass": "Vahvista (ohita rajoitus)",
    "batch_move_to_waitlist": "Siirrä varasijalle",
    "batch_withdraw_confirm_title": "Poista valitut osallistumiset",
    "batch_withdraw_confirm_body": "Haluatko varmasti poistaa {{count}} osallistumista?",
    "participations_withdrawn": "{{count}} osallistumista poistettu",
    "participations_confirmed": "{{count}} osallistumista vahvistettu",
    "participations_moved_to_waitlist": "{{count}} osallistumista siirretty varasijalle",
    "batch_withdraw_failed": "Osallistumisten poistaminen epäonnistui",
    "batch_confirm_failed": "Osallistumisten vahvistus epäonnistui",
    "batch_move_to_waitlist_failed": "Osallistumisten siirto epäonnistui",
    "edit_participation": "Muokkaa osallistujaa",
    "add_team": "Lisää joukkue",
    "no_eligible_series": "Osallistuja ei ole kelpoinen mihinkään sarjaan sukupuolen, iän tai tasoituksen perusteella.",
    "no_series_to_register": "Ei sarjoja saatavilla. Luo sarjat ensin.",
    "confirm_move_to_waitlist": "Haluatko varmasti siirtää osallistujan varasijalle?",
    "withdraw": "Peru osallistuminen",
    "confirm_withdraw_participation": "Haluatko varmasti perua tämän osallistumisen?",
    "participation_withdrawn": "Osallistuminen peruttu",
    "withdraw_failed": "Osallistumisen peruutus epäonnistui",
    "remove_from_team": "Poista joukkueesta",
    "confirm_remove_from_team": "Haluatko varmasti poistaa pelaajan {{name}} joukkueesta?",
    "remove_from_team_failed": "Pelaajan poistaminen joukkueesta epäonnistui",
    "participant_removed": "Pelaaja poistettu joukkueesta",
    "edit_participation_info": "Voit vaihtaa osallistujan sarjaa tässä.",
    "registered_by": "Ilmoittaja",
    "registration_time": "Ilmoittautumisaika",
    "participation_updated": "Osallistuminen päivitetty",
    "participation_created": "Osallistuminen lisätty",
    "update_failed": "Päivitys epäonnistui",
    "result_status_in_progress": "Kesken",
    "result_status_completed": "Valmis",
    "result_status_abandoned": "Keskeytetty",
    "result_status_disqualified": "Hylätty",
    "result_status_withdrawn": "Peruttu",
    "holes_played": "{{count}}/{{total}} reikää",
    "mark_as_paid": "Merkitse maksetuksi",
    "paid": "Maksettu",
    "paid_via_paytrail": "Maksettu verkkomaksulla",
    "select_fee": "Valitse maksu",
    "marked_as_paid": "{{count}} osallistumista merkitty maksetuksi",
    "mark_as_paid_failed": "Maksetuksi merkitseminen epäonnistui",
    "failed_to_load_fees": "Maksujen lataaminen epäonnistui",
    "no_fees_configured": "Ei maksuja määritelty",
    "mark_as_paid_member_paid": "Maksettu",
    "select_members_to_mark_paid": "Valitse jäsenet, jotka merkitään maksetuiksi",
    "multiple_series_selected": "Valittu osallistujia useasta sarjasta",
    "select_price": "Valitse hinta",
    "fee_modal": {
      "compulsory_alert": "Tähän sarjaan kuuluu pakollinen osallistumismaksu. Voit merkitä sen maksetuksi nyt, tai pelaaja voi maksaa sen verkkomaksuna kierrokselle lähtiessään.",
      "voluntary_alert": "Tähän sarjaan kuuluu vapaaehtoinen osallistumismaksu. Voit merkitä sen maksetuksi nyt, tai pelaaja voi maksaa sen verkkomaksuna kierrokselle lähtiessään.",
      "continue_without_payment": "Jatka ilman maksua"
    },
    "ranking_eligible_on": "Vaikuttaa ranking-tuloksiin",
    "ranking_eligible_off": "Ei vaikuta ranking-tuloksiin",
    "cart_wish_on": "Haluaa golfauton",
    "cart_wish_off": "Ei halua golfautoa",
    "cart_wish_column": "Golfauto",
    "fetch_from_profile": "Hae profiilista",
    "fetch_handicap_from_ebirdie": "Hae tasoitustiedot",
    "handicap_factor_help": "Jätä tyhjäksi käyttääksesi kierroksen yleistä tasoituskerrointa. Tämä ylikirjoittaa kierroksen asetukset tälle pelaajalle.",
    "handicap_factor_warning": "Tasoituskerroin {{factor}}% käytössä",
    "selected_tee_label": "Poikkeava tii",
    "selected_tee_help": "Jätä tyhjäksi käyttääksesi sarjan oletustiitä sukupuolen perusteella. Poikkeava tii vaikuttaa slope-tasoituksen laskentaan.",
    "abnormal_tee_indicator": "Poikkeava tii: {{teeName}}",
    "no_user_linked": "Osallistujaan ei ole linkitetty käyttäjäprofiilia",
    "handicap_updated": "Tasoitustiedot päivitetty",
    "no_handicap_in_profile": "Käyttäjäprofiilissa ei ole tasoitusta",
    "failed_to_fetch_handicap": "Tasoituksen hakeminen epäonnistui",
    "fetch_all_handicaps": "Päivitä tasoitustiedot",
    "no_linked_users": "Yhtään osallistujaa ei ole linkitetty käyttäjäprofiileihin",
    "handicaps_updated": "Tasoitukset päivitetty",
    "some_handicaps_failed": "{{count}} tasoituksen haku epäonnistui",
    "failed_to_fetch_handicaps": "Tasoitusten hakeminen epäonnistui",
    "refresh_handicaps_confirm": {
      "title": "Vahvista tasoituksen päivitys",
      "players_have_saved_results_one": "Pelaajalla on jo tallennettu tulos tässä kilpailussa.",
      "players_have_saved_results_other": "Pelaajilla on jo tallennettuja tuloksia tässä kilpailussa.",
      "update_result_playing_handicap": "Päivitä pelitasoitus tuloksiin",
      "ebirdie_submitted_warning": "Tulos on jo lähetetty eBirdieen, eikä pelitasoitusta voi enää päivittää.",
      "skipped_due_to_ebirdie": "Osa pelitasoituspäivityksistä ohitettiin, koska tulokset on jo lähetetty eBirdieen.",
      "batch_explanation": "Näillä pelaajilla on jo tallennettu tulos tässä kilpailussa.",
      "batch_intro": "Päivitä pelitasoitus seuraavien pelaajien tuloksiin:",
      "select_all": "Valitse kaikki",
      "ebirdie_row_label": "{{name}} (eBirdie)"
    },
    "add_multiple_participations": "Lisää useita",
    "add_players": "Lisää pelaajat",
    "all_players_need_series": "Kaikilla pelaajilla täytyy olla sarja valittuna",
    "batch_save_success": "Tallennettu",
    "multiple_series_match": "Pelaajalle löytyy useita sopivia sarjoja",
    "participants_count": "Osallistujia",
    "edit_team": "Muokkaa joukkuetta",
    "add_player_to_team": "Lisää pelaaja joukkueeseen",
    "save_failed": "Tallennus epäonnistui",
    "add_player": "Lisää",
    "add_multiple_players": "Lisää useita",
    "back_to_competitions": "Takaisin kilpailuihin",
    "series_full_title": "Sarja on täynnä",
    "series_full_message": "Sarjan osallistujamäärä on täynnä ({{currentCount}}/{{maxParticipants}}). Oletko varma, että haluat lisätä {{type}}?",
    "competition_full_title": "Kilpailu on täynnä",
    "competition_full_message": "Kilpailun osallistujamäärä on täynnä ({{currentCount}}/{{maxParticipants}}). Oletko varma, että haluat lisätä {{type}}?",
    "series_full_type_player": "pelaajan",
    "series_full_type_players": "pelaajat",
    "series_full_type_team": "joukkueen",
    "add_as_confirmed_player": "Lisää pelaaja",
    "add_as_confirmed_players": "Lisää pelaajat",
    "add_as_confirmed_team": "Lisää joukkue",
    "filter_active": "Osallistujat",
    "filter_cancelled": "Peruneet",
    "filter_unpaid": "Ei-maksetut",
    "filter_button": "Suodata",
    "filter_panel_title": "Suodata osallistujia",
    "filter_group_status": "Tila",
    "filter_group_series": "Sarja",
    "filter_group_club": "Seura",
    "filter_group_gender": "Sukupuoli",
    "filter_apply": "Näytä tulokset ({{count}})",
    "batch_send_email": "Lähetä sähköposti",
    "send_email_modal_title": "Lähetä sähköposti osallistujille",
    "send_email_subject_label": "Aihe",
    "send_email_subject_placeholder": "Esim. Sääpäivitys lauantain kierrokselle",
    "send_email_body_label": "Viesti",
    "send_email_body_placeholder": "Kirjoita viestisi...",
    "send_email_subject_required": "Aihe on pakollinen",
    "send_email_body_required": "Viesti on pakollinen",
    "send_email_send": "Lähetä",
    "send_email_cancel": "Peruuta",
    "send_email_sending": "Lähetetään...",
    "send_email_success": "Sähköposti lähetetty",
    "send_email_failed": "Sähköpostin lähetys epäonnistui",
    "batch_copy_emails": "Kopioi sähköpostit",
    "batch_export_emails_csv": "Lataa sähköpostilista (CSV)",
    "copy_emails_success": "{{count}} sähköpostiosoitetta kopioitu leikepöydälle",
    "copy_emails_failed": "Sähköpostiosoitteiden kopiointi epäonnistui",
    "export_emails_csv_failed": "CSV-tiedoston luominen epäonnistui",
    "sendEmailSwitch": {
      "label": "Lähetä sähköposti",
      "batchLabel": "Lähetä sähköpostit kaikille osallistujille"
    },
    "confirmStatusChange": {
      "title": "Vahvista tilan muutos",
      "body": "Vahvistetaan {{count}} osallistumista.",
      "confirm": "Vahvista",
      "cancel": "Peruuta"
    }
  },
  "paceOfPlay": {
    "warningMessage": "Pelinopeus varoitus",
    "dangerWarning": "Pelinopeus kriittinen!",
    "behindSchedule": "{{minutes}} minuuttia aikataulusta jäljessä",
    "aheadSchedule": "{{minutes}} minuuttia aikataulusta edellä",
    "onPace": "Aikataulussa",
    "status": {
      "onPace": "Aikataulussa",
      "catchingUp": "Kirimässä aikataulua",
      "warning": "Varoitus - hidasta tahtia",
      "danger": "Vaara - erittäin hidas tahti"
    },
    "gap": {
      "rootCause": "Aiheuttaa viivettä",
      "gapToGroupAhead": "Väli edellä olevaan ryhmään",
      "expectedGap": "Odotettu väli",
      "actualGap": "Todellinen väli",
      "unavailable": "Seuranta ei saatavilla",
      "noGroupAhead": "Ensimmäinen lähtö",
      "minutes": "{{minutes}} min"
    },
    "tracking": {
      "enabled": "Seuranta käytössä",
      "disabled": "Seuranta ei käytössä",
      "holesCompleted": "{{holes}} reikää pelattu"
    }
  },
  "payment": {
    "success_title": "Maksu onnistui",
    "success_message": "Ilmoittautumisesi on vahvistettu.",
    "cancelled_title": "Maksu peruutettu",
    "cancelled_message": "Maksua ei suoritettu. Voit yrittää uudelleen.",
    "back_to_competitions": "Takaisin kilpailuihin",
    "fee_label": "Osallistumismaksu",
    "pay_now": "Maksa nyt",
    "complete_payment": "Suorita maksu",
    "paid": "Maksettu",
    "failed_required_title": "Maksu epäonnistui",
    "failed_required_message": "Maksua ei suoritettu, joten ilmoittautumista ei rekisteröity. Voit yrittää uudelleen.",
    "failed_voluntary_title": "Maksu epäonnistui",
    "failed_voluntary_message": "Ilmoittautumisesi on rekisteröity, mutta maksua ei suoritettu. Voit maksaa myöhemmin tai yrittää nyt uudelleen.",
    "retry_payment": "Yritä maksua uudelleen",
    "retry_registration": "Yritä ilmoittautumista uudelleen",
    "back_to_round_start": "Palaa kierroksen aloitukseen",
    "pay_later": "Maksa myöhemmin"
  },
  "weekly_competitions_available": "Viikkokilpailut",
  "select_competitions_to_participate": "Valitse viikkokilpailu, johon haluat osallistua tällä kierroksella",
  "submitted_scores": "Jätetyt tulokset",
  "counting_scores": "Laskettavat tulokset",
  "eligible_series": "Sarjat",
  "eligible_series_singular": "Sarja",
  "series_options_count": "{{count}} vaihtoehtoa",
  "choose_series": "Valitse sarja",
  "failed_to_load_weekly_competitions": "Viikkokilpailujen lataaminen epäonnistui",
  "tee_selection_disabled_by_competition": "Tii määräytyy kilpailun sarjan asetusten mukaan",
  "weekly": {
    "admin_score_entry": "Tuloksen lisäys",
    "competition": "Viikkokilpailu",
    "score_details_for": "Tulokset pelaajalle",
    "no_competitions": "Ei viikkokilpailuja saatavilla",
    "loading_competitions": "Ladataan viikkokilpailuja...",
    "failed_to_load_competitions": "Viikkokilpailujen lataaminen epäonnistui",
    "register_for_competition": "Ilmoittaudu viikkokilpailuun",
    "registered_competitions": "Ilmoittautumiset viikkokilpailuihin",
    "view_results": "Näytä tulokset",
    "position": "#",
    "player": "Pelaaja",
    "series": "Sarja",
    "rounds_played": "Kierrokset",
    "total_score": "Yhteistulos",
    "best_scores": "Parhaat",
    "rounds_counted": "Laskettu",
    "all_scores": "Tulokset",
    "actions": "Toiminnot",
    "view_details": "Tulokset",
    "add_score": "Lisää",
    "date": "Päivämäärä",
    "course": "Kenttä",
    "tee_set": "Tii",
    "strokes": "Lyönnit",
    "stableford_points": "Pisteet",
    "ebirdie_sent_tooltip": "Lähetetty eBirdieen {{date}}, id: {{id}}",
    "status": "Tila",
    "delete": "Poista tulos",
    "delete_score_title": "Poista tulos",
    "no_scores_submitted": "Ei vielä kirjattuja tuloksia",
    "confirm_delete_score": "Haluatko varmasti poistaa tämän tuloksen?",
    "score_deleted": "Tulos poistettu",
    "deleting": "Poistetaan...",
    "view_scorecard": "Näytä tuloskortti",
    "not_weekly_competition": "Tämä ei ole viikkokilpailu",
    "no_results": "Ei tuloksia",
    "insufficient_rounds": "Ei riittävästi kierroksia",
    "payment_required_pill": "Maksu vaaditaan",
    "payment_voluntary_pill": "Maksu vapaaehtoinen"
  },
  "tvLeaderboard": {
    "page": "Sivu {{current}} / {{total}}",
    "updated": "Päivitetty: {{time}}",
    "rank": "SIJ",
    "player": "PELAAJA",
    "leaderScore": "JOHTOTULOS",
    "total": "YHT",
    "today": "TÄNÄÄN",
    "thru": "PELATTU",
    "round": "K",
    "finished": "F",
    "withdrawn": "WD",
    "disqualified": "DQ",
    "loading": "Ladataan tulostaulua...",
    "error_title": "Tulostaulua ei voitu ladata",
    "no_data": "Ei dataa saatavilla",
    "missing_params": "Vaaditut URL-parametrit: seriesId, roundIds",
    "hole": "#",
    "out": "Ulos",
    "in": "Sis",
    "strokes": "Yht",
    "par": "PAR",
    "live": "LIVE",
    "flights_not_published": "Lähtöjä ei ole julkaistu",
    "enterFullscreen": "Siirry koko näytön tilaan",
    "exitFullscreen": "Poistu koko näytön tilasta"
  },
  "handicap_recommendations": {
    "title": "Golfliiton suositukset",
    "disclaimer": "Nämä ovat Suomen Golfliiton suosituksia pelitasoituksista. Voit käyttää niitä sellaisenaan, muokata niitä tai määrittää omat arvot.",
    "multiple_found": "Löytyi useita suosituksia. Valitse sopivin vaihtoehto.",
    "button_label": "Suositukset",
    "button_title": "Näytä Golfliiton suositukset",
    "apply": "Käytä",
    "handicap_factor": "Tasoituskerroin",
    "team_percentages": "Joukkueen %",
    "men_max": "Miehet max",
    "women_max": "Naiset max"
  },
  "player_view": {
    "tabs": {
      "info": "Info",
      "participants": "Osallistujat",
      "flights": "Lähdöt",
      "results": "Tulokset",
      "bracket": "Kaavio",
      "ryder_cup": "Joukkueottelu"
    },
    "status": {
      "registered": "Ilmoittautunut",
      "waitlisted": "Jonotuslistalla"
    },
    "register": "Ilmoittaudu kilpailuun",
    "register_event": "Ilmoittaudu tapahtumaan",
    "join_waitlist": "Ilmoittaudu jonotuslistalle",
    "leave_waitlist": "Poistu jonotuslistalta",
    "cancel_registration": "Peru ilmoittautuminen",
    "cancel_confirm_header": "Peruuta ilmoittautuminen",
    "cancel_confirm_body": "Haluatko varmasti peruuttaa ilmoittautumisesi?",
    "leave_waitlist_confirm_header": "Poistu jonotuslistalta",
    "leave_waitlist_confirm_body": "Haluatko varmasti poistua jonotuslistalta?",
    "waitlist_cancelled_success": "Olet poistunut jonotuslistalta",
    "registration_cancelled_success": "Ilmoittautumisesi on peruutettu",
    "open_live_scoring": "Avaa Live Scoring",
    "open_scoring": "Avaa tulosten syöttö",
    "open_scoring_weekly": "Syötä tulos",
    "info": {
      "pay_competition_fee": "Maksa kilpailumaksu",
      "competition_invitation": "Kilpailukutsu",
      "date": "Ajankohta",
      "registration": "Ilmoittautuminen",
      "registration_closed": "Ilmoittautuminen päättynyt",
      "invite_only": "Kutsukilpailu",
      "participant_count": "Osallistujamäärä",
      "competition_info": "Kilpailuinfo",
      "prices": "Hinnat",
      "no_eligible_series": "Et voi ilmoittautua kilpailuun, koska sinulle sopivaa sarjaa ei löydy.",
      "no_eligible_series_weekly": "Et voi syöttää tulosta, koska sinulle sopivaa sarjaa ei löydy.",
      "restriction": {
        "EBIRDIE_MEMBERS": "Ilmoittautuminen on rajattu Golfliiton jäsenille.",
        "HOME_CLUB_MEMBERS": "Ilmoittautuminen on rajattu kotiseuran pelaajille.",
        "SELECTED_CLUBS": "Ilmoittautuminen on rajattu valittujen seurojen pelaajille.",
        "SOCIETY_MEMBERS": "Ilmoittautuminen on rajattu yhteisön jäsenille."
      },
      "restriction_not_met": "Et täytä ilmoittautumisvaatimuksia.",
      "your_match": "Sinun ottelusi",
      "match_opponent": "Vastustaja",
      "match_round": "Kierros",
      "match_status": "Tila",
      "match_tee_time": "Lähtöaika",
      "match_hole": "Reikä"
    },
    "participants": {
      "header": "Osallistujat",
      "club": "Seura",
      "hcp": "HCP",
      "no_participants": "Ei osallistujia"
    },
    "bracket": {
      "not_published": "Kaaviota ei ole julkaistu"
    },
    "flights": {
      "not_published": "Lähtöjä ei ole julkaistu",
      "tee": "Tii",
      "startHole": "Reikä",
      "player": "Pelaaja",
      "team": "Joukkue",
      "time": "Aika",
      "name": "Nimi",
      "club": "Seura",
      "slope": "Slope",
      "round": "Kierros",
      "no_flights": "Ei lähtöjä",
      "enter_scores": "Syötä tulokset"
    },
    "results": {
      "par": "PAR",
      "played_abbrev": "PEL",
      "score": "Tulos",
      "total_abbrev": "TOT",
      "net": "NET",
      "points": "Pts",
      "finished": "F",
      "no_results": "Ei tuloksia",
      "my_flight": "Oma lähtö",
      "all_players": "Kaikki pelaajat",
      "hole": "Reikä",
      "out": "OUT",
      "in": "IN",
      "series": "Sarja",
      "round": "Kierros"
    },
    "registration": {
      "title": "Kilpailuilmoittautuminen",
      "event_title": "Tapahtumailmoittautuminen",
      "select_series": "Valitse sarja",
      "start_time_preference": "Lähtöaikatoive",
      "start_time_early": "Aikainen",
      "start_time_late": "Myöhäinen",
      "notes": "Lisätietoja",
      "notes_guideline": "Max. 180 merkkiä",
      "notes_placeholder": "Lisätietoja (max. 180 merkkiä)",
      "back": "Takaisin",
      "next": "Seuraava",
      "register": "Ilmoittaudu",
      "continue": "Jatka",
      "terms_title": "Ilmoittautumisehdot",
      "terms_body": "Hyväksyn ilmoittautumisen ehdot, ilmoittautumisen sitovuuden sekä siihen liittyvän kilpailumaksun veloituksen.",
      "terms_body_event": "Hyväksyn ilmoittautumisen ehdot, ilmoittautumisen sitovuuden sekä siihen liittyvän tapahtumamaksun veloituksen.",
      "terms_prompt": "Hyväksytkö ehdot",
      "terms_reject": "En, hylkää",
      "terms_accept": "Kyllä, hyväksyn",
      "confirmed_title": "Ilmoittautunut",
      "waitlisted_title": "Jonotuslistalla",
      "withdrawn_title": "Ilmoittautuminen peruttu",
      "confirmed_message": "Ilmoittautuminen suoritettiin onnistuneesti!",
      "waitlisted_message": "Sinut on lisätty jonotuslistalle!",
      "withdrawn_message": "Ilmoittautumisesi on peruttu onnistuneesti.",
      "back_to_competition": "Takaisin kilpailuun",
      "spots_remaining": "{{count}} paikkaa jäljellä",
      "series_full": "Sarja täynnä",
      "waitlist_available": "Jonotus mahdollinen",
      "error": "Ilmoittautuminen epäonnistui",
      "birthdate_required": "Sarjoissa on käytössä ikärajat. Sinulla ei ole määritettynä syntymäpäivää.",
      "set_birthdate": "Aseta syntymäaika",
      "save_birthdate": "Tallenna",
      "birthdate_card_title": "Lisää syntymäaika",
      "birthdate_card_subtitle": "Sarjoissa on käytössä ikärajat",
      "birthdate_card_action": "Aseta",
      "birthdate_modal_title": "Aseta syntymäaika",
      "birthdate_modal_field_label": "Syntymäaika",
      "birthdate_modal_placeholder": "PP.KK.VVVV",
      "payment_title": "Maksaminen",
      "paid_title": "Maksettu",
      "payment_fee_item": "1 x {{feeName}}",
      "payment_total_label": "Veloitettava summa",
      "payment_secure": "Turvallinen maksaminen",
      "payment_paytrail": "Paytrail on kotimainen",
      "payment_pay_later": "Maksa myöhemmin",
      "payment_go_to_pay": "Siirry maksamaan",
      "payment_error": "Maksun aloitus epäonnistui. Yritä myöhemmin uudelleen.",
      "payment_fee_item_team": "{{count}} x {{feeName}}",
      "payment_per_player": "/ pelaaja",
      "payment_select_players": "Valitse kenelle maksat",
      "payment_select_fee": "Valitse hinta",
      "payment_select_fee_per_player": "Valitse maksu pelaajille",
      "payment_partial_warning": "Maksamatta jäävät pelaajat voivat maksaa myöhemmin",
      "payment_member_already_paid": "Maksettu",
      "payment_all_members_paid": "Kaikki joukkueen jäsenet ovat maksaneet",
      "team_name": "Joukkueen nimi",
      "team_name_placeholder": "Syötä joukkueen nimi",
      "players_count": "Pelaajat {{count}}/{{max}}",
      "search_placeholder": "Nimi tai jäsennumero",
      "search_club": "Seura",
      "search_button": "Hae",
      "search_results": "Hakutulokset",
      "search_add": "Lisää",
      "search_close": "Sulje",
      "search_no_results": "Ei hakutuloksia",
      "register_partial_team": "Ilmoita vajaa joukkue",
      "player_already_registered": "Pelaaja on jo ilmoittautunut",
      "player_ineligible_gender": "Pelaaja ei täytä sarjan sukupuolivaatimusta",
      "player_ineligible_age": "Pelaaja ei täytä sarjan ikävaatimusta",
      "player_ineligible_handicap": "Pelaajan tasoitus ei ole sarjan sallitulla välillä",
      "player_already_added": "Pelaaja on jo lisätty joukkueeseen",
      "cart_wish_label": "Haluan golfauton",
      "cart_wish_checkbox_title": "Golfauto",
      "cart_wish_default_info": "Varmista golfautojen saatavuus caddiemasterilta"
    }
  },
  "not_public_banner": {
    "text": "Tapahtuma ei ole julkinen. Pelaajat eivät näe tätä tapahtumaa kilpailukalenterissa.",
    "textSociety": "Tapahtumaa ei ole vielä julkaistu. Jäsenet eivät näe tätä tapahtumaa ennen julkaisua.",
    "publish_link": "Julkaise.",
    "publish_success": "Tapahtuma julkaistu",
    "publish_failed": "Julkaiseminen epäonnistui"
  },
  "ebirdie": {
    "submit": "Lähetä eBirdieen",
    "cancel_submission": "Peru eBirdie-lähetys",
    "submit_success": "{{count}} tulosta lähetetty eBirdieen",
    "submit_skipped": "{{count}} tulosta ei täytä lähetyksen ehtoja",
    "submit_failed": "{{count}} tuloksen lähetys epäonnistui",
    "no_results": "Ei lähetettäviä tuloksia",
    "submit_error": "eBirdie-lähetys epäonnistui",
    "status_submitted": "Lähetetty eBirdieen",
    "status_queued": "Odottaa lähetystä eBirdieen",
    "status_failed": "eBirdie-lähetys epäonnistui",
    "cancel_confirm_title": "Peru eBirdie-lähetys",
    "cancel_confirm_body": "Haluatko varmasti perua kaikkien tulosten eBirdie-lähetyksen? eBirdie voi hylätä yli 7 päivää vanhat peruutukset.",
    "cancel_confirm_button": "Peru lähetys",
    "cancel_success": "{{count}} tuloksen eBirdie-lähetys peruttu",
    "cancel_skipped": "{{count}} tulosta ohitettu",
    "cancel_failed": "{{count}} tuloksen peruminen epäonnistui",
    "cancel_error": "eBirdie-lähetyksen peruminen epäonnistui",
    "submit_selected": "Vie valitut ({{count}}) eBirdieen",
    "cancel_selected": "Peru valitut ({{count}})"
  },
  "waitlist": {
    "modal": {
      "title": "Kilpailu on täynnä",
      "body": "{{competitionName}} on täynnä. Haluatko ilmoittautua jonoon?",
      "accept": "Kyllä, ilmoittaudu jonoon",
      "decline": "Peruuta"
    },
    "declined_message": "Ilmoittautuminen peruutettu. Kilpailu on täynnä eikä ilmoittautumista jonoon hyväksytty."
  },
  "scorecard_review": {
    "title": "Tuloskortin tarkistus",
    "back_to_scoring": "Takaisin tulosten syöttöön",
    "close": "Sulje ja palaa pääsivulle",
    "previous_player": "Edellinen pelaaja",
    "next_player": "Seuraava pelaaja",
    "return_to_scoring": "Palaa tulosten syöttöön",
    "confirm_and_sign": "Vahvista ja allekirjoita",
    "conflict_warning": "Tällä pelaajalla on konflikteja, jotka on ratkaistu automaattisesti",
    "all_holes_required": "Kaikkien reikien tulokset täytyy syöttää ennen allekirjoittamista",
    "conflicts_must_be_resolved": "Kaikki konfliktit täytyy ratkaista ennen allekirjoittamista",
    "confirm_title": "Vahvista ja allekirjoita tuloskortti",
    "confirm_message": "Oletko varma, että haluat allekirjoittaa tuloskortin?\n\nAllekirjoittamisen jälkeen tuloksia ei voi enää muokata pelaajanäkymästä. Muutokset vaativat järjestelmänvalvojan toimia.",
    "cancel": "Peruuta",
    "sign": "Allekirjoita",
    "signing_error": "Virhe tuloksien allekirjoittamisessa. Yritä uudelleen.",
    "signing_processing": "Allekirjoitetaan...",
    "signing_done": "Allekirjoitettu.",
    "no_results": "Tuloksia ei löytynyt",
    "sign_player": "Allekirjoita tuloskortti",
    "unsign_player": "Peru allekirjoitus",
    "confirm_sign_player": "Haluatko varmasti allekirjoittaa pelaajan {{playerName}} tuloskortin?",
    "signed_badge": "Allekirjoitettu",
    "unsign_error": "Virhe allekirjoituksen perumisessa. Yritä uudelleen.",
    "player_holes_required": "Kaikkien reikien tulokset täytyy syöttää ennen allekirjoittamista",
    "player_conflicts": "Pelaajalla on ratkaisemattomia konflikteja",
    "all_signed_title": "Tuloskortit allekirjoitettu",
    "all_signed_description": "Mikäli haluat muutoksia tuloskortteihin, ole yhteydessä kilpailun järjestäjiin",
    "all_signed_close": "Sulje"
  },
  "special_competitions": {
    "section": {
      "title": "Erikoiskilpailut",
      "add": "Lisää erikoiskilpailu",
      "empty": "Tällä kierroksella ei ole erikoiskilpailuja.",
      "save_first_hint": "Tallenna kierros ennen erikoiskilpailujen lisäämistä.",
      "history": "Tulokset",
      "load_error": "Erikoiskilpailujen lataaminen epäonnistui.",
      "delete_error": "Erikoiskilpailun poistaminen epäonnistui.",
      "confirm_delete_header": "Poista erikoiskilpailu",
      "confirm_delete_body": "Haluatko varmasti poistaa tämän erikoiskilpailun? Kaikki siihen liittyvät merkinnät poistetaan myös."
    },
    "form": {
      "title_add": "Lisää erikoiskilpailu",
      "title_edit": "Muokkaa erikoiskilpailua",
      "name": "Nimi",
      "hole_number": "Reikänumero",
      "unit": "Yksikkö",
      "unit_placeholder": "esim. m, cm, yd",
      "direction": "Voittaja",
      "direction_none": "Viimeisin merkintä",
      "direction_max_wins": "Suurin lukema",
      "direction_min_wins": "Pienin lukema"
    },
    "direction": {
      "MAX_WINS": "Suurin lukema",
      "MIN_WINS": "Pienin lukema"
    },
    "history": {
      "title": "Erikoiskilpailun tulokset: {{name}}",
      "title_generic": "Erikoiskilpailun tulokset",
      "player": "Pelaaja",
      "value": "Tulos",
      "submitted_by": "Merkitsijä",
      "submitted_at": "Aika",
      "empty": "Ei merkintöjä.",
      "load_error": "Tulosten lataaminen epäonnistui.",
      "delete_error": "Merkinnän poistaminen epäonnistui.",
      "confirm_delete_header": "Poista merkintä",
      "confirm_delete_body": "Haluatko varmasti poistaa tämän merkinnän? Edellisestä merkinnästä tulee uusi johtaja.",
      "add_record_submit": "Tallenna tulos",
      "add_record_participant_label": "Pelaaja",
      "add_record_participant_placeholder": "Etsi pelaajaa...",
      "add_record_no_options": "Ei pelaajia",
      "add_record_value_label": "Tulos",
      "add_record_load_error": "Pelaajien lataus epäonnistui",
      "add_record_submit_error_default": "Tuloksen tallennus epäonnistui"
    },
    "panel": {
      "card": {
        "no_leader": "Ei tuloksia",
        "set_button": "Aseta",
        "change_button": "Vaihda"
      },
      "modal": {
        "eyebrow": "Reikä {{hole}} - Lisäkilpailu",
        "help_with_unit": "Valitse pelaaja ja merkitse mitta.",
        "help_no_value": "Valitse pelaaja.",
        "value_label": "Mitta ({{unit}})",
        "submit": "Tallenna",
        "cancel": "Peruuta",
        "cancel_record": "Poista merkintä",
        "cancel_confirm": {
          "title": "Poista merkintä?",
          "confirm": "Poista merkintä",
          "dismiss": "Sulje"
        }
      }
    },
    "results": {
      "title": "Erikoiskilpailut",
      "no_leader": "Ei tuloksia"
    },
    "pdf": {
      "column_hole": "Reikä",
      "column_name": "Kilpailu",
      "column_leader": "Johtaja",
      "column_value": "Tulos",
      "no_leader_yet": "-"
    }
  },
  "publicRankings": {
    "page_title": "Ranking",
    "empty_state": "Ei julkaistuja ranking-sarjoja tälle vuodelle",
    "year_filter_label": "Vuosi",
    "back_to_list": "Takaisin"
  },
  "competitions": {
    "public_view": {
      "linked_ranking_series_label": "Ranking-sarjat"
    }
  },
  "subCompetitions": {
    "tab_label": "Joukkuekilpailu",
    "game_type_label": "Pelimuoto",
    "best_ball": "Best Ball",
    "formation_label": "Joukkueiden muodostus",
    "formation_flight": "Lähtöryhmittäin",
    "formation_club": "Seuroittain",
    "formation_manual": "Manuaalinen",
    "counting_scores_label": "Tuloksia per joukkue",
    "team_column": "Joukkue",
    "no_club": "Ei seuraa",
    "resultTypes": {
      "STROKEPLAY_SCRATCH": "Lyöntipeli Scratch",
      "STROKEPLAY_HCP": "Lyöntipeli HCP",
      "STABLEFORD_SCRATCH": "Pistebogey Scratch",
      "STABLEFORD_HCP": "Pistebogey HCP",
      "MAXIMUMSCORE_SCRATCH": "Maksimitulos Scratch",
      "MAXIMUMSCORE_HCP": "Maksimitulos HCP",
      "SYSTEM36": "System 36"
    },
    "manual": {
      "load_failed": "Joukkuetietojen lataus epäonnistui. Yritä uudelleen.",
      "no_participants_heading": "Kilpailussa ei ole osallistujia",
      "no_participants_body": "Joukkueita ei voi muodostaa, koska kilpailussa ei ole osallistujia.",
      "go_to_participants": "Lisää osallistujia",
      "all_placed_heading": "Kaikki pelaajat sijoitettu",
      "all_placed_body": "Jokainen osallistuja kuuluu joukkueeseen. Voit vapauttaa pelaajan poistamalla hänet joukkueesta.",
      "col_player": "PELAAJA",
      "col_club": "SEURA",
      "col_handicap": "TASOITUS",
      "teams_header": "JOUKKUEET",
      "form_team_button": "Luo joukkue",
      "no_teams_heading": "Ei joukkueita",
      "no_teams_body": "Valitse pelaajia ja luo joukkueita. Voit nimetä joukkueen muodostamisen jälkeen.",
      "default_team_name": "Joukkue {{n}}",
      "rename_tooltip": "Nimeä uudelleen",
      "delete_team_tooltip": "Poista joukkue",
      "remove_player_tooltip": "Poista pelaaja",
      "rename_placeholder": "Joukkueen nimi",
      "rename_save_tooltip": "Tallenna nimi",
      "rename_cancel_tooltip": "Peruuta nimeäminen",
      "edit_teams_button": "Muokkaa joukkueita",
      "status_placed": "sijoitettu",
      "results_button": "Tulokset",
      "formation_save_failed": "Muodostelman tallentaminen epäonnistui. Yritä uudelleen.",
      "create_failed": "Joukkueen luominen epäonnistui. Yritä uudelleen.",
      "rename_failed": "Joukkueen nimeäminen epäonnistui. Yritä uudelleen.",
      "delete_failed": "Joukkueen poistaminen epäonnistui. Yritä uudelleen.",
      "remove_member_failed": "Pelaajan poistaminen epäonnistui. Yritä uudelleen.",
      "confirm_delete_title": "Poista joukkue",
      "confirm_delete_body": "Tämä poistaa joukkueen ja vaikuttaa tuloksiin. Haluatko jatkaa?",
      "confirm_remove_title": "Poista pelaaja joukkueesta",
      "confirm_remove_body": "Tämä poistaa pelaajan joukkueesta ja vaikuttaa tuloksiin. Haluatko jatkaa?"
    }
  }
}
